// Tenant configuration for different customer demos
// Each tenant has a unique path, agent ID, and customization options

const tenants = {
  neuropsych: {
    name: 'NeuroPsych Wellness Center',
    agentId: process.env.REACT_APP_AGENT_ID_NEUROPSYCH,
    path: '/healthcare/neuropsych',
    legacyPath: '/neuropsych',
    description: 'NeuroPsych Wellness Center Demo',
    clientInfo: {
      type: 'Mental Health & Psychiatry',
      address: '3930 Pender Dr, Suite 350, Fairfax, VA 22030',
    }
  },
  amsterdam: {
    name: 'Amsterdam Dental Group',
    agentId: process.env.REACT_APP_AGENT_ID_AMSTERDAM,
    path: '/healthcare/amsterdam-dental',
    legacyPath: '/amsterdam-dental',
    description: 'Amsterdam Dental Group Demo',
    clientInfo: {
      type: 'Dental Practice',
      address: 'Amsterdam, NY',
    }
  },
  healthcare: {
    name: 'Healthcare AI Demo',
    agentId: process.env.REACT_APP_AGENT_ID_HEALTHCARE,
    path: '/healthcare',
    description: 'Healthcare Front Desk Demo',
    clientInfo: {
      type: 'Healthcare Practice',
      address: 'Healthcare Services',
    }
  },
  lawyers: {
    name: 'Legal Partners LLP',
    agentId: process.env.REACT_APP_AGENT_ID_LAWYERS,
    path: '/lawyers',
    description: 'Law Firm Front Desk Demo',
    clientInfo: {
      type: 'Legal Services',
      address: 'New York, NY',
    }
  },
  // Add more tenants as needed
  // Example:
  // example: {
  //   name: 'Example Client',
  //   agentId: process.env.REACT_APP_AGENT_ID_EXAMPLE,
  //   path: '/example',
  //   description: 'Example Client Demo',
  //   clientInfo: {
  //     type: 'Practice Type',
  //     address: 'City, State',
  //   }
  // },
};

// Get tenant config based on current path
export const getTenantFromPath = (pathname) => {
  // Remove trailing slash
  const cleanPath = pathname.replace(/\/$/, '');
  
  // If no path segment (root path), return null for default behavior
  if (!cleanPath) {
    return null;
  }
  
  // Find matching tenant - try exact match first, then legacy path
  for (const [key, tenant] of Object.entries(tenants)) {
    if (tenant.path === cleanPath || tenant.legacyPath === cleanPath) {
      return { key, ...tenant };
    }
  }
  
  // No match found, return null
  return null;
};

// Get tenant config by key
export const getTenant = (key) => {
  return tenants[key] || tenants.neuropsych;
};

// List all available tenants
export const getAllTenants = () => {
  return Object.entries(tenants).map(([key, tenant]) => ({
    key,
    ...tenant,
  }));
};

export default tenants;
